import { useEffect, useRef } from 'react';

export function useRecursiveTimeout(callback = () => {}, delay = 1000) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let timeout;

    async function poll() {
      await savedCallback.current();
      timeout = setTimeout(poll, delay);
    }

    timeout = setTimeout(poll, delay);
    return () => clearTimeout(timeout);
  }, [delay]);
}

/**
 * Very simple poll.
 * Runs the poll and then creates a recursive timeout
 * Tidies itself up when no longer needed.
 *
 * @param {Function} callback
 * @param {Number} delay
 */
export default function usePoll(callback = () => {}, delay = 1000) {
  useRecursiveTimeout(callback, delay);

  useEffect(() => {
    callback();
  }, []);
}
